(() => {
  const describe = (text) => {
    const value = (text || '').toLowerCase();
    if (value.includes('open box')) return ['outlet', 'Open Box', 'Retail packaging is included, but the box or seal has been opened. Review the listing for any product-specific notes.'];
    if (value.includes('no cellophane')) return ['outlet', 'No Cellophane', 'Retail box is present, but the outer cellophane has been removed.'];
    if (value.includes('no box')) return ['outlet', 'No Box', 'Bottle is sold without the manufacturer retail box.'];
    if (value.includes('tester') && value.includes('no cap')) return ['outlet', 'Tester – No Cap', 'Tester presentation sold without a cap. Tester packaging may differ from standard retail packaging.'];
    if (value.includes('tester')) return ['outlet', 'Tester', 'Tester presentation may use different packaging from the standard retail version.'];
    if (value.includes('no cap')) return ['outlet', 'No Cap', 'Bottle is sold without the fragrance cap.'];
    if (value.includes('damaged box')) return ['outlet', 'Damaged Box', 'Outer retail packaging has cosmetic damage; review the listing for any additional notes.'];
    if (value.includes('decant')) return ['decant', 'Decant', 'Fragrance is transferred into a separate travel atomizer and is not the manufacturer full-size retail presentation.'];
    if (value.includes('sealed') || value.includes('full bottle')) return ['sealed', 'Full Bottle', 'Full-size bottle. Use the exact option wording to confirm whether the presentation is sealed or another listed condition.'];
    return [null, 'Selected option', 'The selected size and condition are shown exactly in the option name.'];
  };

  const enhancePicker = (picker) => {
    if (!picker || picker.dataset.ngpEnhanced === 'true') return;
    picker.dataset.ngpEnhanced = 'true';

    const labels = [...picker.querySelectorAll('.variant-option__button-label')];
    labels.forEach((label) => {
      const info = describe(label.textContent.trim());
      if (info[0]) label.dataset.ngpKind = info[0];
    });

    const helper = document.createElement('div');
    helper.className = 'ngp-selected-condition';
    helper.setAttribute('aria-live', 'polite');
    picker.appendChild(helper);

    const update = () => {
      const checked = [...picker.querySelectorAll('input[type="radio"]:checked')];
      const text = checked.map((input) => input.value).join(' · ');
      const info = describe(text);
      helper.innerHTML = '<strong>' + info[1] + '</strong><span>' + info[2] + '</span>';
    };

    picker.addEventListener('change', update);
    update();
  };

  const run = () => document.querySelectorAll('variant-picker').forEach(enhancePicker);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
